// Money is integer centavos everywhere (design doc §2.6). These convert at the input edge
// with string arithmetic, so no float ever touches a price.

/** 2200 → "22.00" */
export function centsToPesos(cents: number): string {
  const sign = cents < 0 ? "-" : "";
  const abs = Math.abs(cents);
  return `${sign}${Math.floor(abs / 100)}.${String(abs % 100).padStart(2, "0")}`;
}

/** "1,250.5" → 125050. Returns null for anything that isn't a peso amount. */
export function pesosToCents(input: string): number | null {
  const match = input.replace(/[₱,\s]/g, "").match(/^(\d+)(?:\.(\d{1,2}))?$/);
  if (!match) return null;
  return Number(match[1]) * 100 + Number((match[2] ?? "").padEnd(2, "0"));
}

/** 685000 → "₱6,850.00", for staff screens showing the stored figure. */
export function formatPesos(cents: number): string {
  const [whole, fraction] = centsToPesos(cents).split(".");
  return `₱${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${fraction}`;
}
